<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Gilla-knapp
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Hjärtat sitter i receptkortets meta-rad och på receptsidan. Klick
      propageras ej — knappen navigerar aldrig. Wrappat i shadcn Button
      <span
        class="font-mono text-[13px] bg-[#f2f4f6] px-1.5 py-0.5 rounded-[5px]"
        >variant="link" size="icon"</span
      >.
    </p>

    <PreviewBox label="Toggle — klicka!">
      <div class="flex items-center gap-6">
        <div class="flex flex-col items-center gap-1.5">
          <button
            class="h-auto p-0 bg-transparent border-none cursor-pointer"
            @click="liked = !liked"
          >
            <PhHeart
              v-if="liked"
              weight="fill"
              :size="24"
              class="text-teal-500"
            />
            <PhHeart
              v-else
              :size="24"
              class="text-slate-400 hover:text-emerald-500"
            />
          </button>
          <span class="font-[Plus_Jakarta_Sans] text-[11px] text-[#6c7a77]">{{
            liked ? "Gillad" : "Ej gillad"
          }}</span>
        </div>
      </div>
    </PreviewBox>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { PhHeart } from "@phosphor-icons/vue";
import PreviewBox from "../components/PreviewBox.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<!-- Gilla-knapp (intern state i RecipeCard) -->
<script setup>
import { ref } from 'vue'
import { PhHeart } from '@phosphor-icons/vue'
const liked = ref(false)
<\/script>

<template>
  <button
    class="flex items-center justify-center w-9 h-9 rounded-full border-none cursor-pointer transition-all"
    :class="liked ? 'bg-rose-50' : 'bg-white'"
    style="box-shadow: 0 1px 4px rgba(0,0,0,0.1)"
    @click="liked = !liked"
  >
    <PhHeart
      :size="18"
      :weight="liked ? 'fill' : 'regular'"
      :color="liked ? '#f43f5e' : '#6c7a77'"
    />
  </button>
</template>`;
const cssCode = `/* Hjärt-ikon (PhHeart) */
/* Gillad (liked=true): */
color: #14b8a6;    /* text-teal-500 */
font-weight: fill;

/* Ej gillad (liked=false): */
color: #94a3b8;    /* text-slate-400 */
/* Hover: */ color: #10b981;  /* hover:text-emerald-500 */

/* Knapp-wrapper */
/* shadcn Button variant=link size=icon */
width: 36px;       /* w-9 */
height: 36px;      /* h-9 */
padding: 0;`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
const liked = ref(false);
</script>
